import { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { frameOverlappedManager } from "@/elements/frame/FrameOverlappedManager";
import type { mindMapWidget } from "@/elements/mindMap/mindMap";
import { DeleteIcon } from "@/icons/widget-menu";
import { selectionManager } from "@/tools/cursorTool";
import type { MenuOptionResult } from "../../types";

export function useDeleteButton(): MenuOptionResult {
    const handleClick = () => {
        const selectedEntities = canv.canvasController.selected;

        function isMindMapWidget(obj: ExtendsOfElementBase): obj is mindMapWidget {
            return obj?.constructorName === "mindMap" && "deleteSelectedNodes" in obj;
        }

        // кейс, когда в mindMap нужно удалить не все, а только отдельно выбранные узлы
        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && isMindMapWidget(child) && child.selected.length !== 0) {
                child.deleteSelectedNodes();
                return;
            }
        }

        const groupsToDelete = frameOverlappedManager.collectGroupsForDeletion(selectedEntities);

        canv.eventManager.openRecord();
        for (const entity of groupsToDelete) {
            canv.canvasController.deleteProcessor(entity);
        }
        canv.eventManager.closeRecord();

        selectionManager.clearSelected();
        canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
    };

    const content = <DeleteIcon />;

    return {
        content,
        handleClick,
    };
}
